// frontend/constants/organization.ts

// 전사 부서 목록 정적 데이터
export const ALL_DEPARTMENTS = ["ICT기술팀", "영업팀", "경영지원팀"];

// 전사 직급 목록 정적 데이터
export const POSITIONS = ["사원", "주임", "대리", "과장", "차장", "부장", "이사", "상무", "전무", "대표이사"];